import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
//import Timer from "./Components/Timer";

ReactDOM.render(<App />, document.getElementById('root'));
